import styled, { css } from 'styled-components';
import {
  getTextType,
  getColor,
  getSpace,
  mq,
  borderShape,
  backgroundShape,
  px2rem
} from '../../../stylesheets/tools';

const StyledDateTeaser = styled.div`
  display: flex;

  > a {
    width: 100%;
  }

  .dateTeaser__copy {
    margin: ${px2rem('5px')} 0 0 0;
    color: ${getColor('teaserGray')};
    line-height: 1.75;
  }

  .dateTeaser__link {
    width: 100%;
    display: flex;
    flex-flow: column;
    padding: 45px 0 45px 0;

    ${mq('m')} {
      flex-flow: row;
      justify-content: space-between;
      padding: 45px 0 45px 0;
    }

    .dateTeaser_capacity {
      display: flex;
      height: auto;
      flex-flow: row;

      .dateTeaser__capacityLabel {
        ${mq('m')} {
          min-width: ${px2rem('250px')};
          max-width: ${px2rem('250px')};
        }
        color: ${props =>
          props.theme.siteTheme.primary !== '#fff' ? props.theme.siteTheme.primary : '#000'};
        ${getTextType('main')};
        ${mq('m')} {
          padding: 0 ${getSpace('m')} 0 ${getSpace('m')};
        }
      }

      .dateTeaser__divider {
        display: none;
        width: 1px;
        height: 100%;
        background: ${getColor('black')};
        opacity: 0.1;

        ${mq('m')} {
          display: flex;
        }
      }
    }

    .dateTeaser__wrapper {
      display: flex;
      flex-flow: column;
      flex-grow: 4;
      ${mq('m')} {
        padding: 0 ${getSpace('xxs')} 0 ${getSpace('l')};
      }

      .dateTeaser__time {
        margin-top: ${getSpace('xxs')};
        ${mq('m')} {
          margin-top: 0;
        }
        ${getTextType('subline')};
      }

      .dateTeaser__headline {
        margin-top: ${getSpace('xxs')};
      }
    }

    .dateTeaser__ctaWrapper {
      display: flex;
      flex-flow: row;
      text-transform: uppercase;
      margin-top: ${getSpace('m')};
      justify-content: space-between;

      ${mq('m')} {
        margin-top: 0;
        min-width: ${px2rem('170px')};
        flex-flow: column;
      }

      a {
        ${getTextType('subline')};
        padding: ${px2rem('18px')} ${px2rem('22px')} ${px2rem('12px')} ${px2rem('25px')};

        ${borderShape()};
        &:hover {
          color: #fff;
          ${backgroundShape()};
        }
      }
      .dateTeaser__ctaShop {
        ${mq('m')} {
          margin-top: ${px2rem('6px')};
        }
        ${getTextType('subline')};
        padding: ${px2rem('18px')} ${px2rem('22px')} ${px2rem('12px')} ${px2rem('25px')};
        ${borderShape()};

        &:hover {
          color: #fff;
          ${backgroundShape()};
        }
      }
    }

    ${props =>
      props.divider &&
      css`
        border-bottom: 1px solid;
        border-bottom-color: rgba(0, 0, 0, 0.1);
      `};
  }
`;

export default StyledDateTeaser;
